import {gmoConnector} from '@/lib/gmoConnector';
import {apiConnector} from "../../lib/apiConnector";

export const actions = {
    // 入力された情報のバリデーションチェックを行う
    validateGmoInput: ({state}) => {
		let errors = [];

		errors.push(gmoConnector.validateCreditCno(state.creditCno));
		errors.push(gmoConnector.validateCreditSno(state.creditSno));
		errors = errors.filter(x => x != '');
		return errors;
    },
    // サブスクリプションの申し込みを開始する
    runSubscription: async ({state, dispatch}, inparam) => {
		// GMO提供のjsを利用しトークンを作成する
		const param = {
			cardno: state.creditCno,
			expire: state.creditLimitYear+('00'+state.creditLimitMonth).slice(-2),
			securitycode: state.creditSno,
		};
		let result = await gmoConnector.getToken(param);
		if(result) {
			if(result.token) {
				if(inparam.continuePayment) {
					result = await dispatch('continueSubscription', {token:result.token, id:inparam.id});
				} else {
					result = await dispatch('applySubscription', {token:result.token, id:inparam.id});
				}
			}
		}
		
		return result;
    },
	// 月額会員を申し込む
	applySubscription: async({getters, rootGetters}, {token, id}) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: rootGetters['commonStore/getAccessToken'],
			x: token,
			id: id
		};
		const rslt = await apiConnector.applySubscription(param);
		return rslt;
	},
	// 半年年間会員の継続を申し込む
	continueSubscription: async({getters, rootGetters}, {token, id}) => {	// eslint-disable-line no-unused-vars
		const param = {
			token: rootGetters['commonStore/getAccessToken'],
			x: token,
			id: id
		};
		const rslt = await apiConnector.continueSubscription(param);
		return rslt;
	},
    // 月額会員の継続を停止する
    cancelSubscription: async ({rootGetters, commit}) => {
		const param = {
			token: rootGetters['commonStore/getAccessToken'],
		};
		const rslt = await apiConnector.cancelSubscription(param);
		if(rslt && rslt.payload) {
			const payload = rslt.payload;
			if(payload.history) {
				commit('commonStore/setListMonthlyLog', payload.history, {root:true});
			}
			if(payload.RecurringID) {
				// ランステ月額自動継続フラグ
				commit('commonStore/setAutoMonthlyFlag', payload.auto, {root:true});
			}
		}
		return rslt;
    },
	// チケットを購入する
	runBuyTicket: async ({state, rootGetters}, {val, usepoint}) => {
		// GMO提供のjsを利用しトークンを作成する
		const param = {
			cardno: state.creditCno,
			expire: state.creditLimitYear+('00'+state.creditLimitMonth).slice(-2),
			securitycode: state.creditSno,
			val: val,
		};
		let result = await gmoConnector.getToken(param);
		if(result) {
			if(result.token) {
				const param = {
					token: rootGetters['commonStore/getAccessToken'],
					x: result.token,
					val: val,
					usepoint: usepoint
				};
				result = await apiConnector.buyTicket(param);
			}
		}
		
		return result;
    },
};

export default {
	actions
};